export default "__VITE_ASSET__503286f8__"